<template>
    <div>
        <template v-if="loading">
            <i class="fas fa-cog fa-spin"></i> Loading...
        </template>
        <template v-else>
            <vue-headful :title="'[Impersonate User] ' + user.first_name + ' '+user.last_name+' - AMOS365'" />

            <h4 class="page-header mb-4">
                <span class="text-muted">
                    <router-link to="/users">Users</router-link> /
                    <router-link :to="`/users/view/${user.id}`">{{ user.first_name }} {{ user.last_name }}</router-link> /
                </span> Impersonate
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card">
                        <div class="card-header">Impersonate User</div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                <strong>Warning:</strong> You are about to login as {{ user.first_name }} {{ user.last_name }}. For all intents and purposes, you will be acting as this user. All actions you take, records you edit, etc. will trigger history tracking and email notifications as this user. Proceed with caution my young Padawan.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-sm btn-warning" :disabled="saving" v-on:click="impersonateUser()">Impersonate {{ user.first_name }} {{ user.last_name }}</button>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">

                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                curTab: 'permissions',
                loading: true,
                saving: false,
                tz: this.$root.timezone,
                id: this.$route.params.id,
                user: {},
            }
        },

        computed: {

        },

        methods: {
            //Get the Customer
            getUser(){
                //Send it
                this.$http.get('/users/view/'+this.id)
                    .then(response => {
                        //Set the user
                        this.user = response.data.user;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            //Do it
            impersonateUser(){
                //Helper
                this.saving = true;

                //Send it
                this.$http.post('/users/impersonate/'+this.id)
                    .then(response => {
                        //Set the user
                        window.location = '/';
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            }
        },

        mounted() {
            //Get the user
            this.getUser();
        }
    }
</script>
